import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { LoadingAnimation } from '../../../../../components/LoadingAnimation'
import { Routes } from '../../../../../constants/Routes'
import { API, IBaseInventorySnapshot } from '@getgreenline/homi-shared'
import { CreateInventorySnapshotModal } from './CreateInventorySnapshotModal'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'

interface Props {
  currentCompanyStore: CurrentCompanyStore
}

interface State {
  inventorySnapshots?: IBaseInventorySnapshot[]
  showCreateModal: boolean
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class InventorySnapshots extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showCreateModal: false,
    }
  }

  componentDidMount() {
    this.load()
  }

  load() {
    const company = this.props.currentCompanyStore!.company!
    API.getInventorySnapshots(company.id).then((snapshots) => {
      this.setState({
        inventorySnapshots: snapshots,
      })
    })
  }

  render() {
    const company = this.props.currentCompanyStore!.company!

    let body: JSX.Element

    const inventorySnapshots = this.state.inventorySnapshots
    if (!inventorySnapshots) {
      body = <LoadingAnimation />
    } else {
      body = (
        <>
          <table className='table table-sm'>
            <thead>
              <tr>
                <th>Date</th>
                <th>Location</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {inventorySnapshots.map((i) => {
                return (
                  <tr key={i.id}>
                    <td>{moment(i.createDate).format('LLLL')}</td>
                    <td>{i.locationName}</td>
                    <td>
                      <Link to={Routes.DASHBOARD_INVENTORY_SNAPSHOT_BY_ID(company.id, i.id)}>
                        View
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </>
      )
    }

    return (
      <div className='container'>
        <br />
        <div className='spaced-button-wrapper'>
          <BlazeButton
            buttonProps={{
              icon: 'arrow-left',
              href: Routes.DASHBOARD_INVENTORY_BULK_UPDATE(company.id),
            }}
            titleProps={{
              title: 'Back',
            }}
          />

          <BlazeButton
            buttonProps={{
              type: 'primary',
              onClick: () => this.setState({ showCreateModal: true }),
            }}
            titleProps={{
              title: 'Create new snapshot',
            }}
          />
        </div>
        <br />
        <div className='border border-secondary p-4'>
          <b>Snapshots capture your inventory at a specific point in time</b>
          <div>
            Canadian compliance laws will require stores to capture their inventory at the start and
            end of their business days.
          </div>
          <div>These snapshots will assist in the generation of those reports.</div>
        </div>
        <br />
        {body}
        {this.state.showCreateModal && (
          <CreateInventorySnapshotModal
            onHide={() => {
              this.setState({ showCreateModal: false })
            }}
            onSubmit={() => {
              this.setState({ showCreateModal: false })
              this.load()
            }}
          />
        )}
      </div>
    )
  }
}
